const getCountDownTimer = (start, eta) => {
    const startDate = new Date(start);
    const etaDate = new Date(eta);

    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;

    function showRemaining() {
        let sign;
        let distance = startDate - etaDate;
        if (distance > 0) {
            sign = '-';
        } else {
            sign = '+';
            distance = -distance;
        }

        const days = Math.floor(distance / _day);
        const hours = Math.floor((distance % _day) / _hour);
        const minutes = Math.floor((distance % _hour) / _minute);
        const seconds = Math.floor((distance % _minute) / _second);

        if (Math.abs(days) > 0) {
            return ['days', days, sign];
        }
        if (Math.abs(hours) > 0) {
            return ['hours', hours, sign];
        }
        if (Math.abs(minutes) > 1) {
            return ['minutes', minutes, sign];
        }
        return ['seconds', seconds, sign];
    }
    return showRemaining();
};

export { getCountDownTimer };
